module.exports = __webpack_public_path__ + "img/Format-introduction.ba28505e.svg";